import React from 'react';
import { connect } from 'react-redux';
import { IDispatchProp } from 'restdux';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
    Menu,
    MenuItem,
} from '@material-ui/core';
import { MoreVert } from '@material-ui/icons';
import { IReturn as Applicant, actions as applicantActions } from '../../../api/resources/Applicant';

// 'TR' marks an applicant as a member of the Transfer bucket (see
// api/applicants/models.py Applicant.TRANSFER). Clearing applicant_intent
// removes them from the bucket.
const TRANSFER_INTENT = 'TR';

interface IViewProps {
    applicant: Applicant;
    onRemoveFromTransfer: () => void;
}

interface IViewState {
    anchorEl: HTMLElement | null;
    menuOpen: boolean;
    confirmOpen: boolean;
}

// Presentational menu + confirmation dialog. Kept free of redux so the
// open/close and confirm flow is trivially unit-testable; the actual
// removal is delegated to onRemoveFromTransfer.
export class MoreActionsMenuView extends React.PureComponent<IViewProps, IViewState> {
    public state: IViewState = {
        anchorEl: null,
        menuOpen: false,
        confirmOpen: false,
    };

    render() {
        const { applicant } = this.props;
        const { anchorEl, menuOpen, confirmOpen } = this.state;

        const inTransferBucket = applicant.applicant_intent === TRANSFER_INTENT;
        // The menu only holds actions relevant to a transfer-bucket applicant,
        // so don't render it at all otherwise (keeps the header uncluttered).
        if (!inTransferBucket) {
            return null;
        }

        return (
            <>
                <IconButton aria-label="More actions" onClick={this.handleOpenMenu}>
                    <MoreVert />
                </IconButton>
                <Menu
                    anchorEl={anchorEl}
                    keepMounted
                    open={menuOpen}
                    onClose={this.handleCloseMenu}
                >
                    <MenuItem onClick={this.handleRemoveClick}>Remove from Transfer bucket</MenuItem>
                </Menu>
                <Dialog open={confirmOpen} onClose={this.handleCancel} aria-labelledby="transfer-remove-title">
                    <DialogTitle id="transfer-remove-title">Remove from Transfer bucket?</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Remove {applicant.first_name} {applicant.last_name} from the Transfer bucket?
                            This clears the Transfer intent on the applicant record.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCancel} color="primary">
                            Cancel
                        </Button>
                        <Button onClick={this.handleConfirm} color="primary">
                            Remove
                        </Button>
                    </DialogActions>
                </Dialog>
            </>
        );
    }

    private handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
        this.setState({ anchorEl: event.currentTarget, menuOpen: true });
    };

    private handleCloseMenu = () => {
        this.setState({ menuOpen: false });
    };

    private handleRemoveClick = () => {
        this.setState({ menuOpen: false, confirmOpen: true });
    };

    private handleCancel = () => {
        this.setState({ confirmOpen: false });
    };

    private handleConfirm = () => {
        this.setState({ confirmOpen: false });
        this.props.onRemoveFromTransfer();
    };
}

type ContainerProps = { applicant: Applicant } & IDispatchProp;

class MoreActionsMenu extends React.PureComponent<ContainerProps> {
    render() {
        const { applicant } = this.props;
        return <MoreActionsMenuView applicant={applicant} onRemoveFromTransfer={this.handleRemoveFromTransfer} />;
    }

    private handleRemoveFromTransfer = () => {
        const { applicant, dispatch } = this.props;
        dispatch(applicantActions.update(applicant.id, { applicant_intent: '' }));
    };
}

export default connect()(MoreActionsMenu);
